import DataItem from 'components/DataItem';
import CruiseItineraryTable from 'components/quoteBooking/CruiseItineraryTable';
import { getStringValue, displayISODateTime } from 'shared/helpers/common';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { DEFAULT_PRIMARY_COLOUR } from 'shared/constants/styleConstants';
import classNames from 'classnames';
import CruiseCabin from './CruiseCabin';

export default function CruisesItem({ cruise, isBooking = false }) {
  const {
    itineraryName,
    cruiseLine,
    cruiseType,
    shipName,
    duration,
    startDate: embarkationDate,
    endDate: disembarkationDate,
    region,
    flightInclusiveAirport,
    flightInclusive,
    extrasComment,
    cabins,
    itinerary,
  } = cruise;

  const getFlightInclusiveDetails = () => {
    if (!flightInclusive) {
      return 'No';
    }

    let flightInclusiveAirportLabel = getStringValue(
      flightInclusiveAirport,
      ' ',
    );
    flightInclusiveAirportLabel = flightInclusiveAirportLabel
      ? `- ${flightInclusiveAirportLabel}`
      : '';

    return `Yes ${flightInclusiveAirportLabel}`;
  };

  const { whiteLabelSettings: { primaryColour } = {} } = useWhiteLabelSettings();

  const backgroundStyle = {
    backgroundColor: primaryColour || DEFAULT_PRIMARY_COLOUR,
  };

  return (
    <div className="bg-white">
      <div style={backgroundStyle} className="mt-[40px] rounded-t-lg text-white text-xl font-bold">
        <div className="p-4 text-[24px] font-medium">
          <div>
            {itineraryName?.trim() || shipName?.trim() || cruiseLine?.trim() || 'Your Cruise'}
          </div>
        </div>
      </div>
      <div className="flex flex-wrap bg-white pt-2 pb-3 px-4 md:px-8 border-b-2 border-dotted">
        <DataItem label="Itinerary Name" value={itineraryName} />
        <DataItem label="Cruise Line" value={cruiseLine} />
        <DataItem label="Cruise Type" value={cruiseType} />
        <DataItem label="Ship Name" value={shipName} />
        <DataItem label="Duration" value={duration} />
        <DataItem
          label="Embarkation Date"
          value={displayISODateTime(embarkationDate)}
        />
        <DataItem
          label="Disembarkation Date"
          value={displayISODateTime(disembarkationDate)}
        />
        <DataItem label="Region" value={region} />
        <DataItem
          label="Cruise Line Flight Inclusive"
          value={getFlightInclusiveDetails()}
        />
        <DataItem
          label={isBooking ? 'Booking Inclusions' : 'Quote Inclusions'}
          value={extrasComment}
        />
      </div>

      {cabins?.length > 0 && (
        <div className="flex flex-wrap bg-white pt-2 pb-3 px-4 md:px-8">
          {cabins.map((cabin, i) => (
            <div
              key={`${i + 1}`}
              className={classNames('pb-4', { 'mt-10': i !== 0 })}
            >
              <CruiseCabin cabin={cabin} />
            </div>
          ))}
        </div>
      )}

      {itinerary?.length > 0 && (
        <div className="bg-white pt-2 pb-8 px-4 md:px-8 sm:px-0">
          <CruiseItineraryTable itinerary={itinerary} />
        </div>
      )}
    </div>
  );
}
